import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-profile-layout',
  templateUrl: './profile-layout.component.html',
  styleUrls: ['./profile-layout.component.scss'],
})
export class ProfileLayoutComponent {
  @Input() fullWidth?: boolean;
  @Input() orgTopbarMargin?: string;
  @Input() wrapperStyle?: { [key: string]: string };
  @Input() contentStyle?: { [key: string]: string };

  protected hideTopbar = true;
}
